import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminNotificationsProvider } from '../context/AdminNotificationsContext';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <AdminNotificationsProvider>
      <div className={`admin-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed((c) => !c)} />
        <Header />
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </AdminNotificationsProvider>
  );
};

export default Layout;
